import React from 'react'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter, REG_FLAGS, FlagBadge } from '../../../Shared/Brand'

export default function Regulation() {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xrg-flags-grid { display: flex; flex-wrap: wrap; gap: 32px; justify-content: center; }
      `}</style>
      <PublicNav active="Company" />

      <section style={{ padding: '130px 24px 60px', textAlign: 'center', background: C.dark, color: C.ltx, borderBottom: `1px solid ${C.dbdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Trust</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 14px' }}>Regulation & Licences</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, maxWidth: '600px', margin: '0 auto' }}>
          Xperia Capital maintains registrations and compliance presence across the following jurisdictions.
        </p>
      </section>

      <section style={{ padding: '72px 24px', maxWidth: '900px', margin: '0 auto' }}>
        <div className="xrg-flags-grid">
          {REG_FLAGS.map(({ country, code }) => (
            <div key={code} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <FlagBadge country={country} size={56} />
              <span style={{ fontSize: '13px', fontWeight: 600, color: C.tx, letterSpacing: '0.04em' }}>{code}</span>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: '64px 24px', borderTop: `1px solid ${C.bdr}`, background: C.light }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3.5vw,34px)', lineHeight: 1.1, margin: '0 0 16px', color: C.tx }}>What This Means For You</h2>
          <p style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, lineHeight: 1.6, marginBottom: '14px' }}>
            Operating across multiple jurisdictions means Xperia Capital is subject to the compliance frameworks, reporting requirements, and client-protection standards set by each relevant regulator.
          </p>
          <p style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, lineHeight: 1.6 }}>
            Exact licence numbers, registration details, and the regulator applicable to your account depend on your jurisdiction of residence. Contact support from your dashboard if you need this confirmed for your specific account.
          </p>
        </div>
      </section>

      <PublicFooter />
    </div>
  )
}
